export const observeSelector = (
	selector: string,
	cb: ( entry: IntersectionObserverEntry ) => void
) => {
	const callback = ( entries: IntersectionObserverEntry[] ) => {
		for ( const entry of entries ) {
			if ( entry.isIntersecting ) {
				cb( entry );
			}
		}
	};
	const observer = new IntersectionObserver( callback, {
		root: null,
		rootMargin: '0px',
		threshold: 0.5,
	} );
	const elements = document.querySelectorAll( selector );
	elements.forEach( ( element ) => observer.observe( element ) );
};
